module.exports = __webpack_public_path__ + "static/media/inferiorClothes.5b6d4eed.jpeg";